export const weddingPackages = [
  { id: 'wp1', icon: 'ri-heart-3-line', popular: false },
  { id: 'wp2', icon: 'ri-vip-crown-line', popular: true },
  { id: 'wp3', icon: 'ri-vip-diamond-line', popular: false },
]

export const weddingGalleryCategories = [
  { id: 'all' },
  { id: 'wedding' },
  { id: 'prewedding' },
  { id: 'rituals' },
]

export const weddingGalleryItems = [
  {
    id: 'wg1',
    category: 'wedding',
    image:
      'https://readdy.ai/api/search-image?query=Tamil%20bride%20and%20groom%20exchanging%20jasmine%20garlands%20during%20a%20traditional%20South%20Indian%20temple%20wedding%20muhurtham%2C%20warm%20golden%20lighting%2C%20candid%20emotional%20moment%2C%20cinematic%20editorial%20photography%2C%20rich%20warm%20tones%2C%20soft%20bokeh%20background&width=900&height=1100&seq=shabi-wg-01&orientation=portrait&nocache=true',
  },
  {
    id: 'wg2',
    category: 'wedding',
    image:
      'https://readdy.ai/api/search-image?query=South%20Indian%20Tamil%20bride%20in%20red%20kanjivaram%20silk%20saree%20with%20temple%20gold%20jewellery%20during%20wedding%20ceremony%2C%20golden%20hour%20light%2C%20elegant%20luxury%20photography%2C%20warm%20amber%20tones%2C%20soft%20dark%20background%2C%20high%20detail&width=900&height=1100&seq=shabi-wg-02&orientation=portrait&nocache=true',
  },
  {
    id: 'wg3',
    category: 'rituals',
    image:
      'https://readdy.ai/api/search-image?query=close%20up%20of%20South%20Indian%20Tamil%20bridal%20hands%20with%20intricate%20mehendi%20and%20gold%20bangles%20during%20a%20wedding%20ritual%2C%20warm%20candle%20lighting%2C%20rich%20detail%2C%20cinematic%20warm%20tones%2C%20shallow%20depth%20of%20field&width=900&height=1100&seq=shabi-wg-03&orientation=portrait&nocache=true',
  },
  {
    id: 'wg4',
    category: 'prewedding',
    image:
      'https://readdy.ai/api/search-image?query=young%20South%20Indian%20Tamil%20couple%20in%20traditional%20attire%20in%20front%20of%20a%20temple%20gopuram%20during%20pre-wedding%20shoot%2C%20warm%20sunset%20light%2C%20cinematic%20wide%20composition%2C%20rich%20amber%20and%20gold%20tones&width=900&height=1100&seq=shabi-wg-04&orientation=portrait&nocache=true',
  },
  {
    id: 'wg5',
    category: 'prewedding',
    image:
      'https://readdy.ai/api/search-image?query=candid%20South%20Indian%20Tamil%20couple%20laughing%20together%20in%20a%20lush%20green%20garden%20during%20pre-wedding%20shoot%2C%20natural%20daylight%2C%20warm%20cinematic%20grade%2C%20joyful%20expressions%2C%20soft%20blurred%20foliage%20backdrop&width=900&height=1100&seq=shabi-wg-05&orientation=portrait&nocache=true',
  },
  {
    id: 'wg6',
    category: 'rituals',
    image:
      'https://readdy.ai/api/search-image?query=South%20Indian%20Tamil%20wedding%20mandapam%20rituals%20with%20sacred%20fire%20and%20priest%20blessing%20the%20couple%2C%20warm%20traditional%20decor%20and%20marigold%20flowers%2C%20cinematic%20warm%20lighting%2C%20editorial%20detail&width=900&height=1100&seq=shabi-wg-06&orientation=portrait&nocache=true',
  },
  {
    id: 'wg7',
    category: 'wedding',
    image:
      'https://readdy.ai/api/search-image?query=South%20Indian%20Tamil%20groom%20and%20bride%20being%20blessed%20with%20rice%20during%20a%20wedding%20ritual%2C%20joyful%20family%20around%20them%2C%20warm%20golden%20lighting%2C%20candid%20documentary%20photography%2C%20rich%20warm%20tones&width=900&height=1100&seq=shabi-wg-07&orientation=portrait&nocache=true',
  },
  {
    id: 'wg8',
    category: 'rituals',
    image:
      'https://readdy.ai/api/search-image?query=South%20Indian%20Tamil%20newlywed%20couple%20blessing%20at%20a%20temple%20with%20oil%20lamps%20and%20flowers%2C%20warm%20devotional%20lighting%2C%20candid%20emotional%20moment%2C%20cinematic%20warm%20amber%20tones%2C%20soft%20bokeh%20background&width=900&height=1100&seq=shabi-wg-08&orientation=portrait&nocache=true',
  },
]

export const weddingFaqIds = ['wf1', 'wf2', 'wf3', 'wf4', 'wf5', 'wf6']

export const coupleTestimonials = [
  {
    id: 'ct1',
    rating: 5,
    image:
      'https://readdy.ai/api/search-image?query=Happy%20South%20Indian%20Tamil%20bride%20and%20groom%20in%20traditional%20wedding%20attire%20smiling%20together%2C%20red%20silk%20saree%20and%20white%20veshti%2C%20warm%20golden%20studio%20backdrop%2C%20soft%20light%2C%20editorial%20wedding%20photography%2C%20rich%20amber%20tones&width=800&height=600&seq=shabi-couple-ct1&orientation=landscape',
  },
  {
    id: 'ct2',
    rating: 5,
    image:
      'https://readdy.ai/api/search-image?query=Joyful%20South%20Indian%20Tamil%20couple%20in%20traditional%20wedding%20dress%20laughing%20together%20during%20a%20reception%2C%20silk%20saree%20and%20sherwani%2C%20warm%20amber%20golden%20tones%2C%20soft%20blurred%20background%2C%20professional%20editorial%20wedding%20photography&width=800&height=600&seq=shabi-couple-ct2&orientation=landscape',
  },
  {
    id: 'ct3',
    rating: 5,
    image:
      'https://readdy.ai/api/search-image?query=South%20Indian%20Tamil%20newlywed%20couple%20in%20traditional%20attire%20with%20jasmine%20flowers%2C%20gentle%20candid%20smile%2C%20warm%20golden%20light%2C%20soft%20neutral%20background%2C%20elegant%20editorial%20wedding%20portrait%2C%20warm%20tones&width=800&height=600&seq=shabi-couple-ct3&orientation=landscape',
  },
]

export const weddingTimeline = [
  { id: 'wt1', step: '01', icon: 'ri-sun-line' },
  { id: 'wt2', step: '02', icon: 'ri-fire-line' },
  { id: 'wt3', step: '03', icon: 'ri-heart-3-line' },
  { id: 'wt4', step: '04', icon: 'ri-group-line' },
  { id: 'wt5', step: '05', icon: 'ri-camera-lens-line' },
  { id: 'wt6', step: '06', icon: 'ri-image-2-line' },
]